<template>
  <div
    :class="totalClasses"
    @click="openBox"
  >
    <div :class="boxWrapClasses">
      <div
        :class="boxClasses"
        ref="box"
      >
        <div class="wrap">
          <SwipeMessage v-if="!open" />
          <SwipeAwayMessage v-if="seal" />
          <Ticket v-if="seal" />
          <div class="half half-left">
            <div class="side"></div>
            <div class="side back back-left"></div>
          </div>
          <div class="half half-right">
            <div class="side">
              <PackageText />
            </div>
            <div class="side back back-right"></div>
          </div>
        </div>
      </div>
      <svg class="bottom" width="283" height="51.11" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 161.94 29.25"><path fill="#0d9fa3" d="M0 29.25L55.81 0h46.52l59.61 29.25H0z"/></svg>
    </div>
    <ProductSwipe
      v-if="open"
      @pick="readyBox"
      @pack="closeBox"
    />
  </div>
</template>

<script>
import Hammer from 'hammerjs'
import SwipeMessage from './SwipeMessage'
import SwipeAwayMessage from './SwipeAwayMessage'
import Ticket from './Ticket'
import PackageText from './PackageText'
import ProductSwipe from './ProductSwipe'
import { trackIntroOpen, trackIntroAway } from '@/utils/track'

export default {
  name: 'IntroPackage',
  data () {
    return {
      open: false,
      pack: false,
      seal: false,
      away: false
    }
  },
  methods: {
    openBox () {
      if (!this.open) {
        this.open = true
        trackIntroOpen()
        window.removeEventListener('scroll', this.handleScroll)
      }
    },
    readyBox () {
      this.pack = true
    },
    closeBox () {
      this.seal = true
    },
    removeBox () {
      this.$emit('remove')
    }
  },
  components: {
    SwipeMessage,
    SwipeAwayMessage,
    Ticket,
    PackageText,
    ProductSwipe
  },
  mounted () {
    const hammer = new Hammer(this.$refs.box)
    hammer.get('swipe').set({
      direction: Hammer.DIRECTION_ALL,
      threshold: 3,
      velocity: 0.1
    })
    hammer.on('swipe', () => {
      this.openBox()

      if (this.seal) {
        this.away = true
        trackIntroAway()
        setTimeout(this.removeBox, 1000)
      }
    })

    window.addEventListener('scroll', this.openBox)
  },
  computed: {
    totalClasses () {
      return {
        'total': true,
        'total-move': this.pack,
        'total-away': this.away
      }
    },
    boxClasses () {
      return {
        'box': true,
        'closed': !this.open,
        'open': this.open,
        'seal': this.seal
      }
    },
    boxWrapClasses () {
      return {
        'box-wrap': true,
        'box-wrap-fade': this.open && !this.pack,
        'box-wrap-pack': this.pack
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.total {
  width: 283px;
  height: 610px;
  margin: 0 auto;
  font-size: 0;
  position: relative;
  transition: transform 2s cubic-bezier(.19,1,.22,1) 2s;
  max-height: 610px;
  will-change: transform, opacity;

  @media (max-width: 479px) {
    width: 250px;
    height: 450px;
    max-height: 450px;
  }
}

.total-move {
  transition: transform 2s cubic-bezier(.19,1,.22,1) 0s;
  transform: translateY(60px);
}

.total-away {
  transition: all 1200ms cubic-bezier(.19,1,.22,1);
  transition-property: transform, opacity;
  transform: translateY(-250px) scale(0.9);
  opacity: 0;
  max-height: 0px;
}

.box-wrap {
  width: 283px;
  height: 510px;
  background-color: #0EB2BE;
  transition: all 2.5s cubic-bezier(0.19, 1, 0.22, 1) 1.25s;
  will-change: transform, opacity;
  transition-property: transform, opacity;
  opacity: 1;
  transform: scale(1);

  @media (max-width: 479px) {
    width: 250px;
    height: 350px;
  }
}

.box-wrap-fade {
  opacity: 0.2;
  transform: scale(0.9);
}

.box-wrap-pack {
  transition: all 1s cubic-bezier(.19,1,.22,1);
  transition-property: transform, opacity;

  .half {
    transition: transform 2s cubic-bezier(0.19, 1, 0.22, 1);

    &::before {
      display: none;
    }
  }
}

.bottom {
  position: absolute;
  bottom: 0;

  @media (max-width: 479px) {
    width: 250px;
    height: 45.14px;
  }
}

.box {
  width: 283px;
  height: 400px;
  margin: 0 auto;
  position: relative;

  @media (max-width: 479px) {
    width: 250px;
    height: 280px;
  }
}

.closed {
  cursor: pointer;
}

.seal {
  cursor: ns-resize;
}

.wrap {
  width: 100%;
  height: 100%;
  perspective: 2000px;
  background: #292A33;
  position: relative;
  z-index: 2;
  perspective-origin: 50% 250%;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border: 5px solid #5ACBD3;
    z-index: 2;
  }
}

.half {
  position: absolute;
  width: 50%;
  height: 100%;
  transform-origin: 0% 50%;
  transition: transform 2.5s cubic-bezier(0.19, 1, 0.22, 1) 400ms;
  transform-style: preserve-3d;
  z-index: 3;

  &::before {
    content: '';
    top: 0;
    bottom: 0;
    width: 17px;
    position: absolute;
    background: #4BD8DB;
    z-index: 1;
  }
}

.half-left {
  left: 1px;

  &::before {
    right: 1px;
  }
}

.half-right{
  transform-origin: 100% 50%;
  right: 1px;
  border-left: 1px dashed #289193;

  &::before {
    left: 0;
  }
}

.side {
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  background-position: center center;
  backface-visibility: hidden;
  background: #5ACBD3;
}

.back {
  transform: rotateY(180deg);
}

.open {
  .half-left {
    transform: rotateY(-160deg);
  }
  .half-right {
    transform: rotateY(160deg);
  }
}

.seal {
  .half-left {
    transform: rotateY(0deg);
  }
  .half-right {
    transform: rotateY(0deg);
  }
}
</style>
